import { LocalStorage } from '../../common/helpers/local-storage';
import { ILoginUser } from '../../common/interfaces/dtos/ILoginUser';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { updateTouchPointConfiguration } from '../../touchpoint/business-logic/touchpoint-configuration';
import { idmLogin } from './service/idm-login';
import { enterTrainingMode } from './service/set-training-mode';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';

export const login = async (user: ILoginUser, useTraningModeAPIs: boolean): Promise<void> => {
  return withSpinner(async () => {
    const data = await idmLogin(user);
    updateSession(user, data);
    tryUpdateTouchPoint(data);

    if (store.getState().posMode.trainingMode) {
      if (store.getState().pinPad.configuration) {
        await updateTouchPointConfiguration();
      }
      if (useTraningModeAPIs) {
        enterTrainingMode();
      }
    }
  });
};

export const updateSession = (user: ILoginUser, loginInfo: ILoginUser): void => {
  if (!loginInfo.userName) {
    loginInfo.userName = user.userName;
  }
  loginInfo.isAuthenticated = true;
  store.dispatch(LoginActions.setLogin(loginInfo));
};

const tryUpdateTouchPoint = (loginInfo: ILoginUser): void => {
  if (loginInfo.touchPointId) {
    LocalStorage.setTillId(loginInfo.touchPointId);
  }
};
